// ignore-string-externalization
import memoize from 'lodash/memoize';
import { getSilentAuthToken } from './silentAuth';
import { getTestAuthToken } from './testAuth';
import SementicMetrics, {
  sendMetric,
  MetricTypes,
} from '@spotify-internal/semantic-metrics';
import { getSlingshotAuthToken, isSlingshot } from './slingshotAuth';

async function getAccessToken() {
  if (process.env.NODE_ENV === 'test') {
    return getTestAuthToken();
  }

  if (isSlingshot) {
    return getSlingshotAuthToken();
  }

  return getSilentAuthToken();
}

let memoizedGetAccessToken = createGetAccessToken();

export const accessTokenManager = {
  get() {
    return memoizedGetAccessToken();
  },

  clear() {
    // clear state by creating new memoized function
    memoizedGetAccessToken = createGetAccessToken();
  },
};

function createGetAccessToken() {
  const cacheKey = 'token';

  const memoized = memoize(
    async () => {
      try {
        // throw new Error('test');
        const [token, expiresIn] = await getAccessToken();
        const expiresInMs = expiresIn * 1000 * 0.9;

        // invalidate cache after expired
        if (expiresInMs < Infinity) {
          setTimeout(() => {
            memoized.cache.delete(cacheKey);
          }, expiresInMs);
        }

        // log count
        sendCount();

        return token;
      } catch (error) {
        // log count with error
        sendCount(true);
        throw error;
      }
    },
    () => cacheKey,
  );

  return memoized;
}

function sendCount(hasError = false) {
  // send if initialized
  if (SementicMetrics.config) {
    sendMetric({
      what: 'get-access-token',
      metric_type: MetricTypes.COUNTER,
      value: 1,
      tags: {
        status: hasError ? 'error' : 'success',
      },
    });
  }
}
